import cn from 'classnames'
import IndicatorDot from 'shared/components/button/IndicatorDot'

type BottomBarProps = {
  totalSteps: number
  stepIndex: number
  onNextStep: () => void
  onPrevStep: () => void
  onCancel: () => void
  onDone: () => void
  onSkip: () => void
  isSubmiting: boolean
  canGoNext: boolean
}

const BottomBar = (props: BottomBarProps) => {
  const {
    totalSteps, //
    stepIndex,
    onNextStep,
    onPrevStep,
    onCancel,
    onDone,
    isSubmiting,
    canGoNext,
    onSkip,
  } = props

  const isLastStep = stepIndex === totalSteps - 1
  const isFirstStep = stepIndex === 0
  const isOptional = [3, 4].includes(stepIndex + 1)

  return (
    <div className="inline-flex h-[50px] w-full items-center justify-between py-4 lg:h-[80px] lg:items-stretch">
      {/* prev/cancel button */}
      <button
        className={cn(
          'rounded-[30px] border border-black/10 px-2 leading-none text-kokushoku-black',
          'disabled:opacity-40 lg:flex-none lg:px-4 lg:hover:shadow',
        )}
        onClick={isFirstStep ? onCancel : onPrevStep}
        disabled={isSubmiting}
      >
        <span className="text-xs font-semibold lg:text-base">{isFirstStep ? 'Cancel' : 'Previous'}</span>
      </button>

      {/* indicator */}
      <div className="flex-1">
        {/* dots */}
        <div className="flex h-full w-full flex-row items-center justify-center lg:gap-1">
          {[...Array(totalSteps)].map((_, index) => {
            return <IndicatorDot index={index} active={index === stepIndex} key={index} className="!w-[12px]" />
          })}

          {/* text */}
          <span className="ml-2 hidden text-[12px] uppercase tracking-wider text-[#808080] transition-all lg:ml-4 lg:block">
            STEP <strong>{stepIndex + 1}</strong> of <strong>{totalSteps}</strong>
          </span>
        </div>
      </div>

      {/* next/done button */}
      {/* desktop */}
      <div className="flex items-center gap-2 lg:items-stretch lg:gap-4">
        <button
          className={cn(
            'lg:mt-0 lg:rounded-[30px] lg:border lg:border-black/10 lg:bg-[#FDFDFD] lg:px-6 lg:py-3 lg:text-base',
            'mt-1 text-xs font-semibold leading-none transition-shadow hover:shadow',
            isOptional && !isLastStep ? 'block' : 'hidden',
          )}
          onClick={onSkip}
        >
          Skip
        </button>
        <button
          className={cn(
            'flex-none rounded-full border border-transparent bg-primary px-2',
            'leading-none text-white hover:shadow disabled:opacity-40 lg:px-4',
          )}
          onClick={isLastStep ? onDone : onNextStep}
          disabled={isSubmiting || !canGoNext}
        >
          <span className="text-xs font-semibold lg:text-base">{isLastStep ? 'Get Recommendations' : 'Continue'}</span>
        </button>
      </div>
    </div>
  )
}

export default BottomBar
